import {
  CUSTOM_QUESTION_TYPES_ID,
  GST_QUESTION_MULTI_QUESTIONS,
  PAN_QUESTION_MULTI_QUESTIONS,
  isMultiQuestionType,
} from "@my-scoot/exly-react-component-lib";
import { answer_types } from "schedule-v2/commonPages/Components/QuestionCards/questionFormConstants";
import { EXTRA_DEFAULT_QUESTION_OPTIONS } from "../constants/QuestionFormFields.constants";

/**
 * Generates a list of question type options by combining base options with any extra options
 * specific to the provided question type.
 *
 * @function generateQuestionTypeOptions
 * @param {Object} params - Parameters for generating options.
 * @param {string} params.questionType - The type of the question for which options need to be generated.
 *
 * @returns {Array} An array of question type options, combining the base options and any
 * additional options for the given question type.
 *
 *
 **/
export const generateQuestionTypeOptions = ({
  questionType,
  isQuestionMultiType,
}) => {
  const baseOptions = answer_types(isQuestionMultiType); // Base options
  const extraOption =
    questionType in EXTRA_DEFAULT_QUESTION_OPTIONS
      ? [EXTRA_DEFAULT_QUESTION_OPTIONS[questionType]]
      : [];

  return [...baseOptions, ...extraOption];
};

export const getMultiQuestionsAsPerQuestionType = (type) => {
  switch (type) {
    case CUSTOM_QUESTION_TYPES_ID.PAN:
      return PAN_QUESTION_MULTI_QUESTIONS;
    case CUSTOM_QUESTION_TYPES_ID.GST:
      return GST_QUESTION_MULTI_QUESTIONS;
    default:
      return [];
  }
};

/**
 * Returns multi-questions with the correct `disabled` state applied.
 * PAN and GST multi-questions that are predefined as disabled will
 * always be enforced as disabled during render.
 */
export const getMultiQuestionsWithDisabledState = (multiQuestions = []) => {
  const disabledMultiQuestions = [
    ...PAN_QUESTION_MULTI_QUESTIONS,
    ...GST_QUESTION_MULTI_QUESTIONS,
  ].filter((q) => q?.disabled === true);
  const questionDisabledMap = disabledMultiQuestions.reduce((acc, q) => {
    acc[q.question] = q?.disabled ?? false;
    return acc;
  }, {});

  return multiQuestions.map((que) => ({
    ...que,
    disabled: questionDisabledMap[que.question] ?? false,
  }));
};

export const hasMultiQuestionType = (questions) => {
  (questions || []).some((q) => isMultiQuestionType(q?.type));
};
